import styled from 'styled-components'
import { bh, bigLg } from 'utils/style-utils'

export const GAME_WIDTHS = {
  lg: '14rem',
  md: '12rem',
  sm: '10rem',
  xs: '9rem',
}

export const gamesContainerPadding = bh

export const StyledContainer = styled.div`
  width: 100%;
  max-width: ${bigLg}px;
  margin: 0 auto;
  padding: ${gamesContainerPadding}px;
`
